import * as actionTypes from './actionTypes';

const axiosPayLoad = {
  rebateCodeSerchResult: [],
  searchScreenData: {
    state: {
      selectClient: 'Client',
    },
  },
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_CODETABLE_DATA:
      return { ...state, rebateCodeSerchResult: action.rebateCodeSerchResult };
    case actionTypes.GET_CONTACT_DETAILS:
      return { ...state, contactDetails: action.contactDetails };
    case actionTypes.GET_CLIENT_DETAILS:
      return { ...state, clientDetails: action.clientDetails };
    case actionTypes.CLIENT_SEARCH_DATA_ACTION_TYPES:
      return { ...state, clientSearchData: action.payload };
    case actionTypes.SET_TAB_VALUE:
      return { ...state, tabValue: action.payload };
    case actionTypes.SET_ERROR_MESSAGES:
      return { ...state, errorMessages: action.payload };
    case actionTypes.SET_REDUX_DATA_SEARCH_SCREEN:
      return { ...state, searchScreenData: action.payload };
    case actionTypes.SET_CLEAR_REDUX_DATA_CLINT:
      return { ...axiosPayLoad };
    default:
      return state;
  }
};

export default reducer;
